export default __webpack_public_path__ + "static/media/GoodLuckPal-Ver7.a65c28e9.mp3";